import React, { FC, useEffect, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { makeSelectLoading, makeSelectVariant } from '../products/selectors';
import { getVariantAction } from '../products/actions';
import { connect } from 'react-redux';
import { Store } from '../../redux/reducers';
import { SelectorProps, Props, PayloadCreate } from './interfaces';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  TextField,
  CardHeader,
  CardContent,
  Card,
  Typography,
  Divider,
} from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiClose, mdiPlusBoxOutline } from '@mdi/js';
import { Controller, useForm } from 'react-hook-form';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { createSellerAction, getSellersAction } from '../sellers/actions';
import { createProviderAction, getProvidersAction } from '../providers/actions';
import { FeatureValues, Seller } from '../createProduct/interfaces';
import { SellerList } from '../sellers/interfaces';
import {
  makeSelectLoading as makeSelectSellerListLoading,
  makeSelectSellersList,
} from '../sellers/selectors';
import {
  makeSelectLoading as makeSelectProviderListLoading,
  makeSelectProvidersList,
} from '../providers/selectors';
import { ProviderList } from '../providers/interfaces';
import SellerModal from '../createProduct/components/sellerModal';
import ProviderModal from '../createProduct/components/providerModal';
import ExternalCodeModal from '../createProduct/components/externalCodeModal';
import Client from 'client-sdk/src/client';
import { UpdateVariantRequestBuilder } from 'client-sdk/src/products/products';
import handleNotfication from '../../utils/handleNotfication.tsx';
import classes from './index.module.scss';
import windowSize from '../../utils/hook/useWindowResize';
import EditVariantsMobile from './mobileView';
import Vitrin from './components/vitrin';

type Inputs = {
  variantCode: string;
  variantId: number;
  sellerName: string;
  providerName: string;
  description: string;
};

const filter = createFilterOptions<SellerList>();

const vitrin = localStorage.getItem('vitrin') || null;
const EditVariants: FC<Props> = ({
  match,
  variantList,
  variantListLoading,
  getProductVariantDispatch,
  createSellerDispatch,
  createProviderDispatch,
  providerList,
  providerListLoading,
  sellerList,
  history,
  sellerListLoading,
  getProvidersDispatch,
  getSellersDispatch,
}: Props): React.ReactElement => {
  const [variantId] = useState<number>(match.params.id);
  const [sellerNameValue, setSellerNameValue] = useState<
    Seller | null | undefined
  >(null);
  const [providerNameValue, setProviderNameValue] = useState<
    ProviderList | null | undefined
  >(null);
  const [sellerName, setSellerName] = useState<string | null>(null);
  const [sellerAddModal, setSellerAddModal] = useState(false as boolean);
  const [providerName, setProviderName] = useState<string | null>(null);
  const [providerAddModal, setProviderAddModal] = useState(false as boolean);
  const [featureValues, setFeatureValues] = useState<FeatureValues[]>([]);
  const [featureModal, setFeatureModal] = useState(false as boolean);
  const [loading, setLoading] = useState(false as boolean);
  const [formData, setFromData] = useState<Inputs | null>(null);
  const [confirmModal, setConfirmModal] = useState(false as boolean);
  const [vitrinSubmit, setVitrinSubmit] = useState(0);
  const token = localStorage.getItem('token') || '';
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  const { control, handleSubmit, errors, setValue, watch, reset } =
    useForm<Inputs>({
      defaultValues: {
        sellerName: '',
        description: '',
        variantCode: '',
        variantId: variantId,
        providerName: '',
      },
    });

  useEffect(() => {
    if (variantId) {
      getProductVariantDispatch({ id: variantId });
    }
  }, [variantId]);

  useEffect(() => {
    getSellersDispatch({ size: 1000 });
    getProvidersDispatch({ size: 1000 });
  }, []);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    if (variantList.id && sellerList.length && providerList.length) {
      const defaultValue = {
        variantCode: variantList.code,
        description: variantList.description,
        sellerName: variantList.sellerName,
        providerName: variantList.providerName,
      };
      const findSeller = sellerList.find(
        el => el.name === variantList.sellerName
      );
      const findProvider = providerList.find(
        el => el.name === variantList.providerName
      );
      if (findSeller) {
        setSellerNameValue(findSeller);
      }
      if (findProvider) {
        setProviderNameValue(findProvider);
      }
      reset(defaultValue);
      if (variantList.features?.length) {
        setFeatureValues(
          variantList.features.map(el => {
            return {
              featureName: el.key,
              valueName: el.value,
            };
          })
        );
      }
    }
  }, [variantList, sellerList, providerList]);

  const handleCloseSellerModal = () => {
    setSellerAddModal(false);
  };

  const handleCloseFeatureModal = () => {
    setFeatureModal(false);
  };

  const submitSeller = (values: Seller) => {
    const callback = () => {
      setSellerAddModal(false);
      setSellerName(null);
    };
    createSellerDispatch({
      body: values,
      pagination: {},
      callback,
    });
  };

  const handleOpenFeatureModal = () => {
    setFeatureModal(true);
  };

  const handleCloseProviderModal = () => {
    setProviderAddModal(false);
  };

  const handleRemoveFeature = (item: FeatureValues) => {
    const selectedIndex = featureValues.findIndex(
      (el: FeatureValues) => el.featureName === item.featureName
    );
    if (selectedIndex > -1) {
      const prevState = [...featureValues];
      prevState.splice(selectedIndex, 1);
      setFeatureValues(prevState);
    }
  };

  const handleAddFeature = (values: FeatureValues) => {
    featureValues.push(values);
    setFeatureModal(false);
  };

  const submitProvider = (values: ProviderList) => {
    const callback = () => {
      setProviderAddModal(false);
      setProviderName(null);
    };
    createProviderDispatch({
      body: values,
      pagination: {},
      callback,
    });
  };

  const submitEditVariant = (values: Inputs) => {
    setFromData(values);
    console.log(formData);
    setConfirmModal(true);
  };

  {
    /*const updateVariantRequest = async () => {
    try {

      setVitrinSubmit(2)


    } catch (err) {
      handleNotfication('ویرایش ویژگی انتخابی با مشکل مواجه شد', 'error');
    } finally {
      setLoading(false);
    }
  };*/
  }
  const updateVariantRequest = async () => {
    try {
      setLoading(true);
      const payload = {
        code: formData?.variantCode,
        description: formData?.description ? formData?.description : undefined,
        id: formData?.variantId ? formData.variantId : variantId,
        productId: variantList.productId,
        providerId: providerList.find(el => el.name === formData?.providerName)
          ?.id,
        sellerId: sellerList.find(el => el.name === formData?.sellerName)?.id,
        featureValues: featureValues.length > 0 ? featureValues : undefined,
      };
      const makeRequest = new UpdateVariantRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      history.push('/your-products');
      handleNotfication('ویرایش ویژگی انتخابی با موفقیت انجام شد', 'success');
    } catch (err) {
      handleNotfication('ویرایش ویژگی انتخابی با مشکل مواجه شد', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseConfirmModal = () => {
    setConfirmModal(false);
    setFromData(null);
  };
  {
    /* isMob ? (
    <EditVariantsMobile />
  ) : */
  }
  return (
    <div className={classes.root}>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`ویرایش ویژگی   ${variantId}`}
            </Typography>
          </div>
        </Paper>
      </Grid>

      <Grid container spacing={5} alignItems="center">
        <Grid container style={{ margin: '20px' }} spacing={6}>
          <form
            style={{ width: '100%' }}
            onSubmit={handleSubmit(submitEditVariant)}
          >
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Grid>
                    <Typography className={classes.typographyCards}>
                      اطلاعات کلی کالا
                    </Typography>
                  </Grid>
                }
              />

              <CardContent className={classes.cardContentOrder}>
                <Grid container lg={12} md={12} className={classes.cardContent}>
                  <Grid container item spacing={2} lg={12} md={12}>
                    {/*by aryan*/}
                    <Grid
                      container
                      item
                      xs={3}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="variantId"
                            control={control}
                            as={
                              <TextField
                                variant="outlined"
                                type="number"
                                fullWidth
                                label="شناسه تنوع کالا"
                                error={!!errors.variantId}
                                disabled={true}
                              />
                            }
                          />
                          <FormHelperText error focused>
                            {errors.variantCode && 'کد تنوع کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>

                    {/*by aryan*/}
                    <Grid
                      container
                      item
                      xs={3}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div style={{ width: '100%' }}>
                          <Controller
                            name="variantCode"
                            control={control}
                            rules={{
                              required: !!(
                                watch('providerName') ||
                                watch('sellerName') ||
                                watch('description') ||
                                featureValues.length
                              ),
                              pattern: /^[A-Za-z\d\-_]+$/,
                            }}
                            as={
                              <TextField
                                variant="outlined"
                                type="text"
                                fullWidth
                                label="کد تنوع کالا"
                                error={!!errors.variantCode}
                                disabled={false}
                              />
                            }
                          />
                          <FormHelperText error focused>
                            {errors.variantCode && 'کد تنوع کالا الزامی میباشد'}
                          </FormHelperText>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={3}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div className={classes.inputHolder}>
                          <Controller
                            style={{ width: '100%' }}
                            control={control}
                            name="sellerName"
                            label="نام فروشنده"
                            render={({ onChange }) => (
                              <Autocomplete
                                disabled={true}
                                id="sellerName"
                                noOptionsText="موردی یافت نشد"
                                value={sellerNameValue!}
                                getOptionSelected={(option, value) =>
                                  option.name === value.name
                                }
                                onChange={(_, newValue: any) => {
                                  if (!newValue) {
                                    setSellerNameValue(null);
                                    setValue('sellerName', '');
                                    return;
                                  }
                                  if (newValue.inputValue) {
                                    setSellerAddModal(true);
                                    setSellerName(newValue.inputValue);
                                    setValue('sellerName', undefined);
                                  } else {
                                    onChange(newValue.name);
                                    setSellerNameValue(newValue);
                                  }
                                }}
                                filterOptions={(options: any, params) => {
                                  const filtered = filter(
                                    options,
                                    params
                                  ) as any;

                                  if (params.inputValue !== '') {
                                    filtered.push({
                                      inputValue: params.inputValue,
                                      name: `اضافه کردن "${params.inputValue}"`,
                                    });
                                  }

                                  return filtered;
                                }}
                                options={sellerList.length ? sellerList : []}
                                getOptionLabel={options => options.name}
                                renderOption={(option: any) => (
                                  <span style={{ display: 'block' }}>
                                    <span>{option?.name}</span>
                                    <br />
                                    <span style={{ fontSize: '10px' }}>
                                      {option?.id}
                                    </span>
                                  </span>
                                )}
                                loadingText="در حال بارگذاری"
                                loading={sellerListLoading}
                                renderInput={params => (
                                  <TextField
                                    variant="outlined"
                                    {...params}
                                    style={{ marginTop: 0, marginBottom: 0 }}
                                    margin="normal"
                                    label="نام فروشنده"
                                    InputProps={{
                                      ...params.InputProps,
                                      type: 'search',
                                      endAdornment: (
                                        <React.Fragment>
                                          {sellerListLoading ? (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={3}
                      md={3}
                      lg={3}
                      alignItems="center"
                    >
                      <div className={classes.item}>
                        <div className={classes.inputHolder}>
                          <Controller
                            style={{ width: '100%' }}
                            control={control}
                            name="providerName"
                            render={({ onChange }) => (
                              <Autocomplete
                                disabled={true}
                                id="providerName"
                                noOptionsText="موردی یافت نشد"
                                value={providerNameValue!}
                                getOptionSelected={(option, value) =>
                                  option.name === value.name
                                }
                                onChange={(_, newValue: any) => {
                                  if (!newValue) {
                                    setProviderNameValue(null);
                                    setValue('providerName', '');
                                    return;
                                  }
                                  if (newValue.inputValue) {
                                    setProviderAddModal(true);
                                    setProviderName(newValue?.inputValue);
                                    setValue('providerName', undefined);
                                  } else {
                                    onChange(newValue.name);
                                    setProviderNameValue(newValue);
                                  }
                                }}
                                filterOptions={(options, params) => {
                                  const filtered = filter(
                                    options,
                                    params
                                  ) as any;

                                  if (params.inputValue !== '') {
                                    filtered.push({
                                      inputValue: params.inputValue,
                                      name: `اضافه کردن "${params.inputValue}"`,
                                    });
                                  }

                                  return filtered;
                                }}
                                options={
                                  providerList.length ? providerList : []
                                }
                                getOptionLabel={options => options.name}
                                renderOption={option => (
                                  <span style={{ display: 'block' }}>
                                    <span>{option?.name}</span>
                                    <br />
                                    <span style={{ fontSize: '10px' }}>
                                      {option?.id}
                                    </span>
                                  </span>
                                )}
                                loadingText="در حال بارگذاری"
                                loading={sellerListLoading}
                                renderInput={params => (
                                  <TextField
                                    variant="outlined"
                                    {...params}
                                    style={{ marginTop: 0, marginBottom: 0 }}
                                    margin="normal"
                                    label="نام تامین کننده"
                                    InputProps={{
                                      ...params.InputProps,
                                      type: 'search',
                                      endAdornment: (
                                        <React.Fragment>
                                          {sellerListLoading ? (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Grid>
                    <Typography className={classes.typographyCards}>
                      ویژگی و مقدار
                    </Typography>
                  </Grid>
                }
                action={
                  <Button
                    disabled={true}
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={handleOpenFeatureModal}
                    startIcon={<Icon path={mdiPlusBoxOutline} size={1} />}
                  >
                    افزودن ویژگی کالا
                  </Button>
                }
              />

              <CardContent className={classes.cardContentOrder}>
                <Grid container lg={12} md={12} className={classes.cardContent}>
                  <Grid container item spacing={2} lg={12} md={12}>
                    {featureValues?.map((field, index) => {
                      return (
                        <>
                          <Grid
                            container
                            item
                            xs={3}
                            md={3}
                            lg={3}
                            alignItems="center"
                          >
                            <div className={classes.item}>
                              <div style={{ width: '100%' }}>
                                <TextField
                                  disabled={true}
                                  id={index}
                                  value={field.featureName}
                                  variant="outlined"
                                  label="ویژگی"
                                  style={{ width: '100%' }}
                                />
                              </div>
                            </div>
                          </Grid>
                          <Grid
                            container
                            item
                            xs={3}
                            md={3}
                            lg={3}
                            alignItems="center"
                          >
                            <div className={classes.item}>
                              <div style={{ width: '100%' }}>
                                <TextField
                                  disabled={true}
                                  value={field.valueName}
                                  variant="outlined"
                                  label="مقدار"
                                  style={{ width: '100%' }}
                                />
                              </div>
                            </div>
                          </Grid>
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {vitrin && (
              <Vitrin
                submit={vitrinSubmit}
                setConfirm={setConfirmModal}
                setVitrinSubmit={setVitrinSubmit}
                id={match.params.id}
                variant={variantList}
              />
            )}
            <Grid
              container
              lg={12}
              md={12}
              xs={12}
              spacing={2}
              style={{
                flexDirection: 'row-reverse',
                position: 'fixed',
                backgroundColor: '#D5DADD',
                bottom: '0',
                right: '75px',
                padding: '15px',
                zIndex: 2,
              }}
            >
              <Grid
                container
                style={{
                  marginLeft: '35px',
                  marginTop: '-4px',
                }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  size="medium"
                  onClick={() => window.history.back()}
                  style={{
                    marginRight: 'auto',
                  }}
                >
                  {'انصراف'}
                </Button>
                <Button
                  type="submit"
                  size="medium"
                  data-cy="search"
                  autoFocus
                  variant="contained"
                  color="primary"
                  style={{
                    marginRight: '14px',
                    marginLeft: '120px',
                  }}
                >
                  ذخیره تغییرات
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <SellerModal
        sellerName={sellerName}
        handleClose={handleCloseSellerModal}
        open={sellerAddModal}
        submitSeller={submitSeller}
        loading={sellerListLoading}
      />
      <ProviderModal
        handleClose={handleCloseProviderModal}
        open={providerAddModal}
        submitProvider={submitProvider}
        loading={providerListLoading}
        providerName={providerName}
      />
      <ExternalCodeModal
        handleClose={handleCloseFeatureModal}
        open={featureModal}
        submitFeature={handleAddFeature}
      />

      <Dialog
        open={confirmModal}
        onClose={handleCloseConfirmModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '5px',
              top: '5px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseConfirmModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از ویرایش ویژگی ${variantId} اطمینان دارید؟`}</div>
          <Divider style={{ width: '100%', marginLeft: '0', marginRight: '0' }} />
        </DialogContent>
        <DialogActions style={{ padding: '20px', textAlign: 'center' }}>
          <Grid container spacing={2}>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseConfirmModal}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                fullWidth
                variant="contained"
                onClick={updateVariantRequest}
                size="large"
                disabled={loading}
                color="primary"
              >
                {'بله'}
              </Button>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  variantList: makeSelectVariant(),
  variantListLoading: makeSelectLoading(),
  sellerList: makeSelectSellersList(),
  sellerListLoading: makeSelectSellerListLoading(),
  providerList: makeSelectProvidersList(),
  providerListLoading: makeSelectProviderListLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getProductVariantDispatch: (payload: any) =>
      dispatch(getVariantAction(payload)),
    createSellerDispatch: (payload: PayloadCreate) =>
      dispatch(createSellerAction(payload)),
    createProviderDispatch: (payload: PayloadCreate) =>
      dispatch(createProviderAction(payload)),
    getSellersDispatch: (payload: any) => dispatch(getSellersAction(payload)),
    getProvidersDispatch: (payload: any) =>
      dispatch(getProvidersAction(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditVariants);
